import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { Usuario } from 'app/interfaces/usuario';
import { AuthService } from 'app/main/pages/authentication/auth.service';
import { SessionStorageService } from 'app/utils/session-storage.service';



@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  permissoes = [];
  usuarioLogado = {} as Usuario;

  /**
   *
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _coreMenuService: CoreMenuService,
    private _sessionStorageService: SessionStorageService,
    private _authService: AuthService) {
    this.permissoes = this._authService.getTokenPermissoes();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();
  }


  // Função para habilitar os menus de acordo com os acessos do usuário;
  habitaliMenus(menu: any) { 
    if (menu.id === 'dashboard') {
      return true;
    } else {
      const menuPermissao = menu.id.toUpperCase() + ".PERMISSAO_LEITURA";
      return this.permissoes?.find(p => p === menuPermissao);
    }
  }

  desabilitaMenuComSubMenu(menu: any) {
    let exibeMenu = false;
    menu.children?.forEach(m => {
      if (!exibeMenu) {
        const menuPermissao = m.id.toUpperCase() + ".PERMISSAO_LEITURA";
        exibeMenu = !!this.permissoes?.find(p => p === menuPermissao);
      }
    });

    return exibeMenu;
  }
}
